/**
 * Created by Kieran on 27/09/2017.
 */

import axios from 'axios'
import config from '../../config'

let RegistrationApi = {
  register(model) {
    return axios.post(config.apiUrl + 'register/initial/v2/', model)
  },
  amend(model) {
    return axios.put(config.apiUrl + 'register/amend', model)
  },
  complete(model) {
    return axios.put(config.apiUrl + 'register/complete', model)
  }
};



export default RegistrationApi;



// WEBPACK FOOTER //
// ./src/api/Registration/index.js